/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import {
  Card,
  Descriptions,
  Layout,
  Row,
  Col,
  Table,
  Input,
  Space,
  Button,
  Tag
} from 'antd'
import { EyeOutlined, FilePdfOutlined, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import moment from 'moment'
import { useLocation } from 'react-router-dom'
import { connect } from 'react-redux'
import debounce from 'lodash.debounce'
import { useNavigate } from 'react-router'
import { DefaultLayout } from 'src/layouts/default'
import { Gap } from 'src/components/atoms/Gap'

export const _PreviewCoupon = ({ loading, meta, data, token, dispatch }) => {
  const { state } = useLocation()
  const navigation = useNavigate()

  useEffect(() => {
    dispatch({
      type: 'coupon_claimers/get_coupon_claimers',
      payload: {
        token,
        params: { couponId: state?.id }
      }
    })
  }, [])

  const onHandleSearch = (e) => {
    const { target } = e

    dispatch({
      type: 'coupon_claimers/get_coupon_claimers',
      payload: { token, params: { q: target.value, couponId: state?.id } }
    })
  }

  const onHandlePaginate = (page, pageSize) => {
    dispatch({
      type: 'coupon_claimers/get_coupon_claimers',
      payload: { token, params: { page: page, couponId: state?.id } }
    })
  }

  const onHandlePreviewClaimer = (obj) => {
    navigation(`/dashboard/coupon/${state?.id}/detail/${obj.id}/claimers`, {
      state: { couponId: state?.id, ...obj }
    })
  }

  const columns = [
    {
      title: 'No',
      dataIndex: 'no',
      align: 'center',
      width: 20,
      render: (text, obj, index) => <a>{index + 1}</a>,
      fixed: 'left'
    },
    {
      title: 'Name',
      dataIndex: 'name',
      align: 'center'
    },
    {
      title: 'Total Claim',
      dataIndex: 'count',
      align: 'center'
    },
    {
      title: 'Phone',
      dataIndex: 'phone',
      align: 'center'
    },
    {
      title: 'Batch No',
      dataIndex: 'customCode',
      align: 'center',
      render: (txt) => <>{txt || '-'}</>
    },
    {
      title: 'Action',
      dataIndex: 'action',
      align: 'center',
      render: (txt, obj, index) => {
        return (
          <Space>
            <Button
              size='small'
              className='button-detail'
              onClick={() => onHandlePreviewClaimer(obj)}
            >
              <EyeOutlined />
              Detail
            </Button>
          </Space>
        )
      }
    }
  ]

  return (
    <DefaultLayout>
      <Layout.Content className='container-detail-product'>
        <Card>
          <Row>
            <Col span={16}>
              <Descriptions title='Detail Coupon (grouped-by-phone)'>
                <Descriptions.Item label='Coupon'>
                  {state.coupon}
                </Descriptions.Item>
                <Descriptions.Item label='Claim Limit Per User Phone'>
                  {state.limitClaim ? state.limitClaim : 'Unlimited'}
                </Descriptions.Item>
                <Descriptions.Item label='Claim Limit Per QR'>
                  {state.limitClaimPerQr ? state.limitClaimPerQr : 'Unlimited'}
                </Descriptions.Item>
                <Descriptions.Item label='Periode'>
                  {moment(state.startDate).format('L')} -{' '}
                  {moment(state.endDate).format('L')}
                </Descriptions.Item>
                <Descriptions.Item label='Discount (%)'>
                  {state.discountCalculated.percentage}%
                </Descriptions.Item>
                <Descriptions.Item label='Discount (Rp)'>
                  Rp{' '}
                  {Intl.NumberFormat('id').format(
                    state.discountCalculated.priceDiscounted
                  )}
                </Descriptions.Item>
                <Descriptions.Item label='Redirect Type'>
                  {state.redirect === 'default' && 'Opim Default'}
                  {state.redirect === 'custom' && 'Custom Page'}
                  {state.redirect === 'noredirect' && 'No Redirect'}
                </Descriptions.Item>
                <Descriptions.Item label='PDF Ebook'>
                  {state.downloadPdfEbook
                    ? (
                      <Space>
                        <Tag color='success' icon={<CheckCircleOutlined />}>
                          Available
                        </Tag>
                        <Button
                          type='link'
                          size='small'
                          icon={<FilePdfOutlined />}
                          href={state.downloadPdfEbook}
                          target='_blank'
                        >
                          Download
                        </Button>
                      </Space>
                      )
                    : (
                      <Tag color='default' icon={<CloseCircleOutlined />}>
                        Not Available
                      </Tag>
                      )}
                </Descriptions.Item>
                <Descriptions.Item label='Send WA Notif'>
                  {state.sendWaNotif ? 'Yes' : 'No!'}
                </Descriptions.Item>
              </Descriptions>
            </Col>
            <Col span={8}>
              <Input
                allowClear
                onChange={debounce(onHandleSearch, 500)}
                placeholder='Search'
              />
            </Col>
          </Row>
          <Gap height='1rem' />
          <Table
            rowKey='id'
            columns={columns}
            dataSource={data ?? []}
            rowSelection={{
              type: 'checkbox'
            }}
            loading={loading}
            scroll={{ x: 'max-content' }}
            pagination={
              meta && {
                defaultPageSize: meta.itemsPerPage,
                total: meta.totalItems,
                pageSize: meta.itemsPerPage,
                onChange: (page, pageSize) => onHandlePaginate(page, pageSize)
              }
            }
          />
        </Card>
      </Layout.Content>
    </DefaultLayout>
  )
}

const mapStateToProps = ({ reducerCouponClaimers }) => {
  return { ...reducerCouponClaimers }
}

export const PreviewCoupon = connect(mapStateToProps)(_PreviewCoupon)

_PreviewCoupon.propTypes = {
  dispatch: PropTypes.func,
  token: PropTypes.string,
  loading: PropTypes.bool,
  meta: PropTypes.object,
  data: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.array])
}
